const timeThreshold = {
  ALL: {
    value: Number.MAX_SAFE_INTEGER - 1,
    label: "At any time",
  },
  MONTHS_12: {
    value: 365,
    label: "12 Months",
  },
  MONTHS_24: {
    value: 365 * 2,
    label: "24 Months",
  },
  MONTHS_36: {
    value: 365 * 3,
    label: "36 Months",
  },
  MONTHS_48: {
    value: 365 * 4,
    label: "48 Months",
  },
  MONTHS_60: {
    value: 365 * 5,
    label: "60 Months",
  },
};

const timeThresholdList = [
  timeThreshold.MONTHS_12,
  timeThreshold.MONTHS_24,
  timeThreshold.MONTHS_36,
  timeThreshold.MONTHS_48,
  timeThreshold.MONTHS_60,
  timeThreshold.ALL,
];

const countries = {
  FINLAND: "Finland",
  SWEDEN: "Sweden",
  NORWAY: "Norway",
  DENMARK: "Denmark",
  ICELAND: "Iceland",
  ALL: "All",
};

const countryList = [
  countries.ALL,
  countries.FINLAND,
  countries.SWEDEN,
  countries.NORWAY,
  countries.DENMARK,
  countries.ICELAND,
];

const stages = {
  ALL: {
    value: "",
    label: "Full search (incl. Google Search)",
  },
  REGISTRY: {
    value: "Linked at the registration",
    label: "Registry only",
  },
};

const stageList = [stages.ALL, stages.REGISTRY];

const multicenter = {
  ALL: "Both",
  YES: "Yes",
  NO: "No",
};

const enrollment = {
  ALL: {
    lower: 0,
    upper: Number.MAX_SAFE_INTEGER,
    label: "All",
  },
  UNDER_100: {
    lower: 0,
    upper: 99,
    label: "<100",
  },
  OVER_99_UNDER_500: {
    lower: 100,
    upper: 500,
    label: "100-500",
  },
  OVER_500: {
    lower: 501,
    upper: Number.MAX_SAFE_INTEGER,
    label: ">500",
  },
};

const enrollmentList = [
  enrollment.ALL,
  enrollment.UNDER_100,
  enrollment.OVER_99_UNDER_500,
  enrollment.OVER_500,
];

const multicenterList = [multicenter.ALL, multicenter.YES, multicenter.NO];

const identificationStep = {
  CROSS_REFERENCE: "Cross-reference",
  LINKED_AT_THE_REGISTRATION: "Linked at the registration",
  OTHER: "Other",
  SYSTEMATIC_GOOGLE_SEARCH: "Systematic Google search",
};

const phase = {
  ALL: "All",
  I: "I",
  I_II: "I/II",
  II: "II",
  II_III: "II/III",
  III: "III",
  IV: "IV",
  NA: "NA/Unknown",
};

const phaseList = [
  phase.ALL,
  phase.I,
  phase.I_II,
  phase.II,
  phase.II_III,
  phase.III,
  phase.IV,
  phase.NA,
];

const centerSize = {
  ALL: "All",
  LARGE: "large",
  SMALL: "small",
};

const centerSizeList = [centerSize.ALL, centerSize.LARGE, centerSize.SMALL];

const sponsorType = {
  ALL: {
    label: "All",
    value: "All",
  },
  NON_INDUSTRY: {
    label: "Non-industry only",
    value: "Only non-industry",
  },
  MIXED: {
    label: "Industry or Mixed",
    value: "Industry or mixed",
  },
};

const sponsorTypeList = [
  sponsorType.ALL,
  sponsorType.NON_INDUSTRY,
  sponsorType.MIXED,
];

const controlled = {
  ALL: {
    label: "All",
    value: "All",
  },
  YES: {
    label: "Yes",
    value: "Yes",
  },
  NO: {
    label: "No",
    value: "No",
  },
};

const controlledList = [controlled.ALL, controlled.YES, controlled.NO];

const registry = {
  ALL: {
    label: "All",
    value: "All",
  },
  CTGOV: {
    label: "ClinicalTrials.gov",
    value: "ctgov",
  },
  EUCTR: {
    label: "European Union Clinical Trials Register",
    value: "euctr",
  },
};

const registryList = [registry.ALL, registry.CTGOV, registry.EUCTR];

export {
  countries,
  countryList,
  stages,
  stageList,
  identificationStep,
  multicenter,
  multicenterList,
  enrollment,
  enrollmentList,
  phase,
  phaseList,
  centerSize,
  centerSizeList,
  timeThreshold,
  timeThresholdList,
  sponsorType,
  sponsorTypeList,
  controlled,
  controlledList,
  registryList,
  registry,
};
